import {
  Box,
  Input,
  Text,
  VStack,
  HStack,
  IconButton,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { updateWhatsAppEmail } from '../../../hooks/whatsapp_number';

export default function EditEmailPage() {
  const navigate = useNavigate();
  const { orgId, whatsappNumberId } = useParams();
  const toast = useToast();

  const [email, setEmail] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!orgId || !email.trim()) return;

    setSaving(true);

    const res = await updateWhatsAppEmail(
      whatsappNumberId || '',
      orgId,
      email.trim(),
    );

    setSaving(false);

    if (res.success) {
      toast({
        title: 'Email updated',
        status: 'success',
        duration: 1500,
      });
      navigate(-1);
    } else {
      toast({
        title: 'Update failed',
        description: 'Unable to update Email',
        status: 'error',
        duration: 3000,
      });
    }
  };

  return (
    <Box bg="white" minH="100vh">
      {/* Header */}
      <HStack px={4} py={3} justify="space-between">
        <IconButton
          aria-label="Back"
          icon={<ArrowLeft />}
          variant="ghost"
          onClick={() => navigate(-1)}
        />

        <Text fontWeight="semibold">Email</Text>

        {saving ? (
          <Spinner size="sm" />
        ) : (
          <Text
            color="#25D366"
            fontWeight="medium"
            cursor="pointer"
            onClick={handleSave}
          >
            Save
          </Text>
        )}
      </HStack>

      {/* Content */}
      <VStack px={4} mt={4} spacing={2} align="stretch">
        <Input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          placeholder="business@email.com"
          variant="flushed"
          autoFocus
        />
        <Text fontSize="xs" color="gray.500">
          This email will be visible in your WhatsApp business profile.
        </Text>
      </VStack>
    </Box>
  );
}
